// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3sjfe","item":"PaymentsMobile_item__3WADg","label":"PaymentsMobile_label__2C43C","amount":"PaymentsMobile_amount__K230c"};